import React, { useState } from "react";
import "./auth.css";
import create_pass_img from "../../Asserts/Images/CretaeNewpassImg.png";
import logo from "../../Asserts/Logo/Logo.png";
import { MdOutlineRemoveRedEye, MdOutlineVisibilityOff } from "react-icons/md";
import { message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import Instance  from "../../AxiosConfig";

const CreateNewPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || "";

  const handleCreatePassword = async () => {
    // ✅ Form validations
    if (!password || !confirmPassword) {
      message.warning("Please fill in both password fields.");
      return;
    }

    if (password.length < 8) {
      message.warning("Password must be at least 8 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      message.error("Passwords do not match!");
      return;
    }

    if (!email) {
      message.error("Email is missing. Please restart the password reset process.");
      return;
    }

    try {
      setLoading(true);
      const response = await Instance.post("/auth/reset-password", {
        email: email,
        newPassword: password,
        confirmPassword: confirmPassword,
      });
      console.log("Change Password Response:", response);
      if (response.data) {
        message.success("Password changed successfully!");
        
        navigate("/");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-password-container">
      <div className="container-fluid">
        <div className="row">
          
          <div className="col-md-6">
            <div className="create-pass-img">
              <img src={create_pass_img} alt="Create New Password" />
            </div>
          </div>

           
          <div className="col-md-6">
            <div className="create-pass-form">
              <center>
                <img src={logo} alt="Logo" className="logo" />
              </center>

              <div className="create-pass-content">
                <h2>Create New Password</h2>
                <p>“Please create your new password”</p>
              </div>

              {/* New Password Field */}
              <div className="mt-2">
                <label className="form-label create-pass-label">
                  Create New Password*{" "}
                  <span className="create-pass-label-span">
                    Must be at least 8 characters
                  </span>
                </label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter new password"
                  />
                  <span
                    className="eye-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <MdOutlineVisibilityOff />
                    ) : (
                      <MdOutlineRemoveRedEye />
                    )}
                  </span>
                </div>
              </div>

              {/* Confirm Password Field */}
              <div className="mt-2">
                <label className="form-label create-pass-label">
                  Re-enter New Password*
                </label>
                <div className="password-input-container">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Re-enter new password"
                  />
                  <span
                    className="eye-icon"
                    onClick={() =>
                      setShowConfirmPassword(!showConfirmPassword)
                    }
                  >
                    {showConfirmPassword ? (
                      <MdOutlineVisibilityOff />
                    ) : (
                      <MdOutlineRemoveRedEye />
                    )}
                  </span>
                </div>
              </div>

              <div className="mt-3">
                <button
                  className="create-pass-btn"
                  onClick={handleCreatePassword}
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Create New Password"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNewPassword;
